import { request } from '@/utils/request'
import SearchResult from './models/searchResult'

export default {
    async search(query, types, limit) {
        query = query || ''
        types = types || []
        limit = limit || 50

        const params = {
            query,
            types,
            limit,
        }

        return SearchResult.fromGrouped(await request.get('/api/search', params))
    },
}
